import { render, staticRenderFns } from "./achievementsComp.vue?vue&type=template&id=17445897"
import script from "./achievementsComp.vue?vue&type=script&lang=js"
export * from "./achievementsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports